var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { b64D } from './helpers';
const cK = window.thk.custCK;
const removeBackground = (uploadedFile) => __awaiter(void 0, void 0, void 0, function* () {
    if (cK) {
        const bodyFormData = new FormData();
        bodyFormData.append('image_file', uploadedFile);
        bodyFormData.append('size', 'auto');
        bodyFormData.append('format', 'png');
        bodyFormData.append('crop', 'true');
        const response = yield fetch('https://api.remove.bg/v1.0/removebg', {
            method: 'POST',
            headers: { 'X-Api-Key': b64D(cK) },
            body: bodyFormData,
        });
        if (response.ok) {
            return yield response.arrayBuffer();
        }
        else {
            throw new Error(`${response.status}: ${response.statusText}`);
        }
    }
    else {
        throw new Error('Missing Key');
    }
});
export default removeBackground;
